import React from 'react';

import { Container, ImageContainer, ImagesListContainer } from './styles';

export const GridImagesPreview = ({ images = [] }: { images?: string[] }) => {
  const [selected, setSelected] = React.useState(0);

  return (
    <Container>
      <ImageContainer style={{ width: '100%' }}>
        <img src={images[selected]} />
      </ImageContainer>
      <ImagesListContainer>
        {images.map((item, index) => (
          <ImageContainer
            key={item.toString()}
            style={{ width: '120px' }}
            onClick={() => setSelected(index)}
          >
            <img src={item} />
          </ImageContainer>
        ))}
      </ImagesListContainer>
    </Container>
  );
};
